import { React, useState } from "react";
import "./view-fleet.scss";
import Fleet from "./fleet-management";
import Supplier from "./supplier";
import { useStore } from "../../store/store";
import { checkIsInternalSourcing } from "../../util/constantUtility";

const ViewFleet = () => {
  const { user, saveUser } = useStore();

  return (
    <div className="view-fleet-wrapper">
      {checkIsInternalSourcing(user?.userRole) ? <Supplier /> : <Fleet />}
    </div>
  );
};

export default ViewFleet;
